// @ts-strict-ignore
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { SUBSCRIPTION_GROUPS_KEY } from "./constants";
import type { SubscriptionGroupPayload } from "./types";
import { isSubscriptionGroupPayload } from "./validators";

export const getLineSubscriptionGroups = reactQueryFetcherAdapter(
  SUBSCRIPTION_GROUPS_KEY,
  (signal, appGroupId: string, limit?: number): Promise<SubscriptionGroupPayload> => {
    return fetch(
      `/engagement/${appGroupId}/line_subscription_groups`,
      "GET",
      { query: null, limit },
      {
        signal,
      }
    );
  },
  isSubscriptionGroupPayload
);
